import { render } from "./ImpressaoTransferenciaInternaSimplificada.vue?vue&type=template&id=39473934"
import script from "./ImpressaoTransferenciaInternaSimplificada.vue?vue&type=script&lang=js"
export * from "./ImpressaoTransferenciaInternaSimplificada.vue?vue&type=script&lang=js"

import "./ImpressaoTransferenciaInternaSimplificada.vue?vue&type=style&index=0&id=39473934&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__